import {
    HiOutlineUser,
    HiOutlineUsers,
    HiOutlineChartBar,
    HiOutlineQuestionMarkCircle,
    HiOutlineLogout,
    HiOutlineClipboardCheck,
    HiOutlineDesktopComputer,
    HiOutlineChartPie,
    HiOutlineExclamation,
    HiOutlineDocumentReport,
    HiOutlineCalendar,
    HiOutlineGlobeAlt,
    HiOutlineDocumentDuplicate,
    HiOutlineNewspaper,
    HiOutlineBriefcase,
    HiOutlineUserGroup,
    HiOutlineUserAdd,
    HiOutlinePencilAlt,
    HiOutlineArchive,
    HiOutlineClipboard,
    HiOutlineOfficeBuilding,
    HiOutlineBell,
    HiOutlineBookOpen,
    HiOutlineHeart,
    HiOutlineCreditCard,
    HiOutlineX
} from "react-icons/hi";
import { FaFileInvoiceDollar } from "react-icons/fa";

// Main navigation items for regular users organized by groups
export const mainNavGroups = [
    {
        title: "Personal",
        items: [
            {
                icon: <HiOutlineUser />,
                title: "My Profile",
                path: "/",
            },
            {
                icon: <HiOutlineClipboard />,
                title: "My Tasks",
                path: "/my-tasks",
            },
            {
                icon: <HiOutlineClipboardCheck />,
                title: "Performance Review",
                path: "/performance-review",
            },
        ]
    },
    {
        title: "Core Work",
        items: [
            {
                icon: <HiOutlineDesktopComputer />,
                title: "Game/App Testing",
                path: "/game-testing",
            },
            {
                icon: <HiOutlineChartPie />,
                title: "Testing Analytics",
                path: "/testing-analytics",
            },
            {
                icon: <HiOutlineExclamation />,
                title: "Bug Resolution",
                path: "/bug-resolution",
            },
            {
                icon: <HiOutlineClipboard />,
                title: "Bugs Assigned to Me",
                path: "/bugs-assigned-to-me",
            },
        ]
    },
    {
        title: "Management",
        items: [
            {
                icon: <HiOutlineDocumentReport />,
                title: "Claim Management",
                path: "/claim-management",
            },
            {
                icon: <HiOutlineCreditCard />,
                title: "My Subscriptions",
                path: "/my-subscriptions",
            },
            {
                icon: <HiOutlineCalendar />,
                title: "Leave Management",
                path: "/leave-management",
            },
            {
                icon: <HiOutlineBriefcase />,
                title: "My Recruitment Reviews",
                path: "/recruitment/reviews",
                requiresRecruitmentAssessor: true,
            },
        ]
    },
    {
        title: "Company",
        items: [
            {
                icon: <HiOutlineUserGroup />,
                title: "Know the Myelinners",
                path: "/know-myelinners",
            },
            {
                icon: <HiOutlineUsers />,
                title: "Know the Advisors",
                path: "/know-advisors",
            },
            {
                icon: <HiOutlineBookOpen />,
                title: "HR Policies",
                path: "/hr-policies",
            },
            {
                icon: <HiOutlineHeart />,
                title: "Culture & Tenets",
                path: "/culture-tenets",
            },
        ]
    },
    {
        title: "Other",
        items: [
            {
                icon: <FaFileInvoiceDollar />,
                title: "Payslips",
                path: "/profile",
                onClick: () => {
                    // Set active tab to payslips in profile
                    sessionStorage.setItem('profileActiveTab', 'payslips');
                }
            },
            {
                icon: <HiOutlineBell />,
                title: "Notifications",
                path: "/notifications",
            },
        ]
    }
];

// Backward compatibility - flatten groups into single array
export const mainNavItems = mainNavGroups.flatMap(group => group.items);

// Admin navigation items organized by groups
export const adminNavGroups = [
    {
        title: "Personal",
        items: [
            {
                icon: <HiOutlineUser />,
                title: "My Profile",
                path: "/profile",
            }
        ]
    },
    {
        title: "Team Management",
        items: [
            {
                icon: <HiOutlineOfficeBuilding />,
                title: "Employee Management",
                path: "/admin/employee-management",
                subItems: [
                    {
                        icon: <HiOutlineUserAdd />,
                        title: "Invite Employee",
                        path: "/admin/add-employee",
                    },
                    {
                        icon: <HiOutlinePencilAlt />,
                        title: "Edit Employee",
                        path: "/admin/edit-employee",
                    },
                    {
                        icon: <HiOutlineUsers />,
                        title: "View Employees",
                        path: "/admin/view-employees",
                    },
                    {
                        icon: <HiOutlineArchive />,
                        title: "Archived Users",
                        path: "/admin/archived-users",
                    },
                    {
                        icon: <HiOutlineUsers />,
                        title: "Advisors",
                        path: "/admin/advisors",
                    }
                ]
            },
            {
                icon: <HiOutlineClipboardCheck />,
                title: "Assign Tasks",
                path: "/admin/assign-tasks",
            },
            {
                icon: <HiOutlineChartBar />,
                title: "Employee Performance",
                path: "/admin/performance-review",
            },
            {
                icon: <HiOutlineClipboardCheck />,
                title: "Approvals",
                path: "/admin/approvals",
            },
            {
                icon: <HiOutlineX />,
                title: "Terminate",
                path: "/admin/terminate",
            }
        ]
    },
    {
        title: "Hiring",
        items: [
            {
                icon: <HiOutlineBriefcase />,
                title: "Job Posts",
                path: "/admin/job-posts",
            },
            {
                icon: <HiOutlineDocumentReport />,
                title: "Applications Inbox",
                path: "/admin/applications",
            },
            {
                icon: <HiOutlineClipboardCheck />,
                title: "Recruitment",
                path: "/admin/recruitment",
            },
            {
                icon: <HiOutlineBriefcase />,
                title: "Assessor Reviews",
                path: "/recruitment/reviews",
            }
        ]
    },
    {
        title: "Testing",
        items: [
            {
                icon: <HiOutlineDesktopComputer />,
                title: "Admin Game Testing",
                path: "/admin/game-testing",
            }
        ]
    },
    {
        title: "Content",
        items: [
            {
                icon: <HiOutlineNewspaper />,
                title: "Blogs",
                path: "/admin/blogs",
            },
            {
                icon: <HiOutlineNewspaper />,
                title: "News",
                path: "/admin/news",
            },
            {
                icon: <HiOutlineDocumentDuplicate />,
                title: "Documents",
                path: "/admin/documents",
            }
        ]
    },
    {
        title: "Operations",
        items: [
            {
                title: 'Payslips',
                path: '/admin/payslips',
                icon: <FaFileInvoiceDollar />
            },
            {
                icon: <HiOutlineCreditCard />,
                title: "Subscriptions Tracker",
                path: "/admin/subscriptions-tracker",
            },
            {
                icon: <HiOutlineArchive />,
                title: "Archive",
                path: "/admin/archive",
            }
        ]
    },
];

// Backward compatibility - flatten groups into single array
export const adminNavItems = adminNavGroups.flatMap(group => group.items);

// Bottom navigation items
export const bottomNavItems = [
    {
        icon: <HiOutlineQuestionMarkCircle />,
        title: "Help",
        path: "/help",
    },
    {
        icon: <HiOutlineGlobeAlt />,
        title: "Domain Migration",
        path: "/admin/domain-migration",
    },
    {
        icon: <HiOutlineClipboardCheck />,
        title: "PPC Feedback",
        path: "/ppc-feedback",
    },
    {
        icon: <HiOutlineLogout />,
        title: "Logout",
        path: "#",
        isLogout: true,
    },
];
